// extracted by mini-css-extract-plugin
export default {"ProjectStatusSelector":"ProjectStatusSelector_ProjectStatusSelector__BkO1s"};